import {fetchCurrentStudentType} from '../../../redux/actions/student-type';
import Fetcher from '../../shared/fetches/fetcher';
import {Segment} from 'semantic-ui-react';
import UpdateStudentTypeForm from './form';

function UpdateStudentTypeContainer() {
  return (
    <Fetcher
      action={fetchCurrentStudentType}
      stateSelector={state => state.studentType}
    >
      {studentType => (
        <Segment>
          <p className='text-center my-4'>
            <span>شما در حال حاضر داوطلب دوره </span>
            <span className='text-bold'>{studentType.name}</span>
            <span> هستید.</span>
          </p>
          {studentType.isUpdatable ? (
            <UpdateStudentTypeForm studentType={studentType}/>
          ) : (
            <p className='text-center'>دوره فعلی شما قابل تغییر نمی‌باشد.</p>
          )}
        </Segment>
      )}
    </Fetcher>
  );
}

export default UpdateStudentTypeContainer;
